import { render, staticRenderFns } from "./Procedure.vue?vue&type=template&id=6454104e"
import script from "./Procedure.vue?vue&type=script&lang=js"
export * from "./Procedure.vue?vue&type=script&lang=js"
import style0 from "./Procedure.vue?vue&type=style&index=0&id=6454104e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports